(function () {
  if (window.customCartDrawerInitialized) return;
  window.customCartDrawerInitialized = true;

  function $id(id) { return document.getElementById(id); }
  function findQty(line) {
    var el = document.querySelector('[data-line="'+line+'"] .custom-qty-count');
    return el ? parseInt(el.textContent, 10) || 0 : 0;
  }

  function openDrawerAfterRefresh() {
    var overlay = $id('custom-cart-overlay');
    var drawer = $id('custom-cart-drawer');
    if (overlay) overlay.classList.add('custom-active');
    if (drawer) drawer.classList.add('custom-active');
    document.body.classList.add('page-scroll-disabled');
  }
  function closeDrawer() {
    var overlay = $id('custom-cart-overlay');
    var drawer = $id('custom-cart-drawer');
    if (overlay) overlay.classList.remove('custom-active');
    if (drawer) drawer.classList.remove('custom-active');
    document.body.classList.remove('page-scroll-disabled');
  }

  // Toggle recommendations panel
  function toggleRecommendations() {
    const recommendPanel = document.querySelector('.custom-cart-recommend');
    const cartMain = document.querySelector('.custom-cart-main');
    
    if (recommendPanel && cartMain) {
      recommendPanel.classList.toggle('hidden');
      cartMain.classList.toggle('expanded');
    }
  }

  // Discount Code Functionality
  function initializeDiscountFunctionality() {
    const discountInput = document.getElementById('discount-code-input');
    const applyDiscountBtn = document.getElementById('apply-discount-btn');
    const discountMessage = document.getElementById('discount-message');
    const appliedDiscountsContainer = document.getElementById('applied-discounts');

    if (!discountInput || !applyDiscountBtn) return;

    // Apply discount code
    applyDiscountBtn.addEventListener('click', applyDiscountCode);

    // Allow Enter key to apply discount
    discountInput.addEventListener('keypress', function(e) {
      if (e.key === 'Enter') {
        applyDiscountCode();
      }
    });

    // Remove discount functionality
    if (appliedDiscountsContainer) {
      appliedDiscountsContainer.addEventListener('click', function(e) {
        if (e.target.classList.contains('discount-remove')) {
          const discountCode = e.target.getAttribute('data-discount-code');
          removeDiscountCode(discountCode);
        }
      });
    }

    function applyDiscountCode() {
      const discountCode = discountInput.value.trim();
      
      if (!discountCode) {
        showDiscountMessage('Please enter a discount code', 'error');
        return;
      }

      showDiscountMessage('Applying discount...', 'loading');
      applyDiscountBtn.disabled = true;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `discount=${encodeURIComponent(discountCode)}`
      })
      .then(response => response.json())
      .then(data => {
        if (data.errors) {
          showDiscountMessage(data.errors, 'error');
        } else {
          // Success - refresh the cart drawer to show updated totals
          customRefreshCartDrawer().then(() => {
            discountInput.value = '';
            showDiscountMessage('Discount applied successfully!', 'success');
            // Re-initialize discount functionality after refresh
            setTimeout(initializeDiscountFunctionality, 100);
          });
        }
      })
      .catch(error => {
        console.error('Error applying discount:', error);
        showDiscountMessage('Error applying discount. Please try again.', 'error');
      })
      .finally(() => {
        applyDiscountBtn.disabled = false;
      });
    }

    function removeDiscountCode(discountCode) {
      showDiscountMessage('Removing discount...', 'loading');

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: `discount=`
      })
      .then(response => response.json())
      .then(data => {
        if (data.errors) {
          showDiscountMessage('Error removing discount', 'error');
        } else {
          customRefreshCartDrawer().then(() => {
            showDiscountMessage('Discount removed successfully!', 'success');
            // Re-initialize discount functionality after refresh
            setTimeout(initializeDiscountFunctionality, 100);
          });
        }
      })
      .catch(error => {
        console.error('Error removing discount:', error);
        showDiscountMessage('Error removing discount. Please try again.', 'error');
      });
    }

    function showDiscountMessage(message, type) {
      if (!discountMessage) return;
      
      discountMessage.textContent = message;
      discountMessage.className = 'discount-message';
      
      if (type === 'success') {
        discountMessage.classList.add('discount-success');
      } else if (type === 'error') {
        discountMessage.classList.add('discount-error');
      } else if (type === 'loading') {
        discountMessage.classList.add('discount-loading');
      }

      // Clear message after 5 seconds
      setTimeout(() => {
        if (discountMessage) {
          discountMessage.textContent = '';
          discountMessage.className = 'discount-message';
        }
      }, 5000);
    }
  }

// Refresh cart drawer with dynamic content
function customRefreshCartDrawer() {
  window.updateCartCount();
  var url = window.location.pathname + '?section_id=custom-cart-drawer';
  return fetch(url, { credentials: 'same-origin' })
    .then(res => res.text())
    .then(html => {
      try {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newSection = doc.getElementById('custom-cart-drawer-section');

        if (!newSection) return;

        // Check if cart is empty in the new content
        const newCartItems = newSection.querySelector('#custom-cart-items');
        const isCartEmpty = newCartItems && newCartItems.querySelector('.custom-cart-empty');
        
        // Update recommendations if they exist and cart is not empty
        const newRecommend = newSection.querySelector('.custom-cart-recommend');
        const curRecommend = document.querySelector('.custom-cart-recommend');
        
        if (newRecommend && !isCartEmpty && curRecommend) {
          curRecommend.innerHTML = newRecommend.innerHTML;
        } else if ((!newRecommend || isCartEmpty) && curRecommend) {
          // Remove recommendations if they were removed or cart is empty
          curRecommend.remove();
          document.querySelector('.custom-cart-main').classList.add('expanded');
        } else if (newRecommend && !isCartEmpty && !curRecommend) {
          // Add recommendations if they were added and cart is not empty
          const cartDrawer = document.querySelector('#custom-cart-drawer');
          cartDrawer.insertBefore(newRecommend, document.querySelector('.custom-cart-main'));
          document.querySelector('.custom-cart-main').classList.remove('expanded');
        }

        // Update cart items
        const newItems = newSection.querySelector('#custom-cart-items');
        const curItems = document.querySelector('#custom-cart-items');
        if (newItems && curItems) curItems.innerHTML = newItems.innerHTML;

        // Update subtotal and total
        const newSubtotal = newSection.querySelector('#custom-cart-subtotal');
        const curSubtotal = document.querySelector('#custom-cart-subtotal');
        if (newSubtotal && curSubtotal) curSubtotal.innerHTML = newSubtotal.innerHTML;

        const newHeading = newSection.querySelector('#custom-cart-heading');
        const curHeading = document.querySelector('#custom-cart-heading');
        if (newHeading && curHeading) curHeading.innerHTML = newHeading.innerHTML;

        // CRITICAL FIX: Update or remove shipping progress based on cart state
        const newShippingContainer = newSection.querySelector('.drawer-prograssbar');
        const curShippingContainer = document.querySelector('.drawer-prograssbar');
        
        if (newShippingContainer && !isCartEmpty && curShippingContainer) {
          // Update existing shipping progress when cart has items
          curShippingContainer.innerHTML = newShippingContainer.innerHTML;
        } else if ((!newShippingContainer || isCartEmpty) && curShippingContainer) {
          // Remove shipping progress when cart is empty
          curShippingContainer.remove();
        } else if (newShippingContainer && !isCartEmpty && !curShippingContainer) {
          // Add shipping progress when cart has items but progress bar was missing
          const cartHeader = document.querySelector('.custom-cart-header');
          if (cartHeader) {
            // Insert after the heading and close button container
            const headerFlex = cartHeader.querySelector('.flex.align-items-center.justify-content-between');
            if (headerFlex && headerFlex.nextSibling) {
              headerFlex.parentNode.insertBefore(newShippingContainer, headerFlex.nextSibling);
            } else {
              cartHeader.appendChild(newShippingContainer);
            }
          }
        }

        // Update cart footer with discount functionality
        const newFooter = newSection.querySelector('.custom-cart-footer');
        const curFooter = document.querySelector('.custom-cart-footer');
        if (newFooter && curFooter) {
          curFooter.innerHTML = newFooter.innerHTML;
        } else if (!newFooter && curFooter) {
          curFooter.remove();
        } else if (newFooter && !curFooter && !isCartEmpty) {
          document.querySelector('.custom-cart-main').appendChild(newFooter);
        }

        // Update data attributes
        const newCartDrawer = newSection.querySelector('#custom-cart-drawer');
        const curCartDrawer = document.querySelector('#custom-cart-drawer');
        if (newCartDrawer && curCartDrawer) {
          curCartDrawer.setAttribute('data-free-shipping-threshold', newCartDrawer.getAttribute('data-free-shipping-threshold'));
          curCartDrawer.setAttribute('data-free-shipping-threshold-money', newCartDrawer.getAttribute('data-free-shipping-threshold-money'));
        }

        // Update cart drawer class based on empty state
        if (isCartEmpty) {
          curCartDrawer.classList.add('empty-cart-drawer');
        } else {
          curCartDrawer.classList.remove('empty-cart-drawer');
        }

        // Re-attach event listeners only if cart has items
        if (!isCartEmpty) {
          // Initialize discount functionality after refresh
          setTimeout(initializeDiscountFunctionality, 100);
        }

        // Dispatch event for any external listeners
        document.dispatchEvent(new Event('customCartDrawerRefreshed'));

      } catch (err) {
        console.error('customRefreshCartDrawer parse error', err);
      }
    });
}
// Global function to update cart count in <text> tag
  window.updateCartCount = function() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        const count = cart.item_count;
        const cartText = document.querySelector('text.header__icon--cart');
        if (cartText) {
          cartText.textContent = count;
        }
      })
      .catch((error) => {
        console.error('Error fetching cart count:', error);
      });
  };

  // Cart update function
  function customUpdateCart(line, quantity) {
    var payload = { line: parseInt(line, 10), quantity: parseInt(quantity, 10) };
    
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
    .then(() => {
      // Refresh cart drawer and update cart count
      return customRefreshCartDrawer()
        .then(openDrawerAfterRefresh)
        .then(() => window.updateCartCount());
    })
    .catch(err => console.error('customUpdateCart error', err));
  }
  function customAddToCart(variantId, qty) {
    var payload = { id: parseInt(variantId, 10), quantity: parseInt(qty || 1, 10) };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    })
    .then(() => customRefreshCartDrawer().then(openDrawerAfterRefresh))
    .catch(err => console.error('customAddToCart error', err));
  }

  window.customOpenCart = function () { 
    customRefreshCartDrawer().then(openDrawerAfterRefresh); 
  };
  window.customCloseCart = closeDrawer;
  window.customUpdateCart = customUpdateCart;
  window.customAddToCart = customAddToCart;
  window.toggleRecommendations = toggleRecommendations;

  document.addEventListener('click', function (e) {
    var overlay = e.target.closest('#custom-cart-overlay');
    if (overlay) { closeDrawer(); return; }

    var openBtn = e.target.closest('[data-action="open-cart"]');
    if (openBtn) { window.customOpenCart(); return; }

    var closest = e.target.closest('[data-action]');
    if (!closest) return;

    var action = closest.getAttribute('data-action');
    var line = closest.getAttribute('data-line');

    if (action === 'increase') {
      var cur = findQty(line);
      customUpdateCart(line, cur + 1);
    } else if (action === 'decrease') {
      var cur = findQty(line);
      customUpdateCart(line, Math.max(cur - 1, 0));
    } else if (action === 'remove') {
      customUpdateCart(line, 0);
    } else if (action === 'close-drawer') {
      closeDrawer();
    } else if (action === 'close-recommendations') {
      toggleRecommendations();
    }
  }, false);

  // Initialize recommendation listeners and discount functionality on page load
  document.addEventListener('DOMContentLoaded', function() {
    initializeDiscountFunctionality();
  });

  // Initialize discount functionality when cart drawer is opened
  document.addEventListener('customCartDrawerRefreshed', function() {
    setTimeout(initializeDiscountFunctionality, 100);
  });

})();